import { graphql } from 'react-relay';

export type { pdpSharedRecentlyFavoritedRootQuery as pdpSharedRecentlyFavoritedRootQueryType } from './__generated__/pdpSharedRecentlyFavoritedRootQuery.graphql.ts';

export const pdpSharedRecentlyFavoritedRootQuery = graphql`
    query pdpSharedRecentlyFavoritedRootQuery(
        $userId: String!
        $itemId: String!
        $isTrade: Boolean!
        $priceBookName: String!
        $fetchUser: Boolean!
    ) {
        viewer {
            ...PdpSharedRecentlyFavoritedCarousel_viewer
        }
    }
`;
